import { Button, colors, typography } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled, { CSSProp } from 'styled-components';
import { MedicalConditionStatus } from 'store/modules/subscriber-imq/types';

export const MedicalConditionEntryStyled = styled.div<{
  $status: MedicalConditionStatus;
}>`
  border: 1px solid ${colors.neutral[300]};
  border-radius: 4px;
  padding: 1rem 2rem;
  display: grid;
  grid-template-columns: 1.5fr 1.5fr 16rem 16rem;
  gap: 1rem;
  align-items: center;
  position: relative;

  &::before {
    content: '';
    display: block;
    width: 0.5rem;
    height: 100%;
    position: absolute;
    left: 0;
    background-color: ${({ $status }): CSSProp =>
      $status === MedicalConditionStatus.DETAILS_MISSING ? colors.red[600] : colors.green[600]};
    border-radius: 3px 0 0 3px;
  }

  ${breakpointsMQ4.lg.down} {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 1rem 1.2rem 1rem 1.6rem;
  }
`;

export const ConditionNameStyled = styled.div`
  ${typography.regular[16]};
  color: ${colors.neutral[900]};
  overflow-wrap: anywhere;
`;

export const AffectedPeopleStyled = styled.div`
  ${typography.regular[16]};
  color: ${colors.neutral[900]};
  overflow-wrap: anywhere;
`;

export const ManageConditionButtonStyled = styled(Button)`
  justify-self: end;

  ${breakpointsMQ4.sm.down} {
    justify-self: start;
    width: 100%;
  }
`;
